
export const personalVideo = {
  title: "PERSONAL VIDEO MESSAGE",
  subtitle: "Custom, personalized video message directly from me, for special occasions or motivational purposes.",
  backButton: "Back to Pumped Gabo's page",
  choosePlan: "CHOOSE A VIDEO MESSAGE PACKAGE",
  planDescription: "Select the video message package that suits you best and impress your loved ones or friends with a personalized message from me. Perfect surprise for any occasion!",
  deliveryTime: "Delivery time:",
  chooseButton: "Select",
  howItWorks: "HOW DOES IT WORK?",
  step1: "Choose the appropriate video message package from the options above.",
  step2: "Fill out the order form so I know exactly what message you want and who it's for.",
  step3: "Pay for the order and I'll create the personalized video message within the specified timeframe.",
  step4: "I'll send the video to the provided email address, from where you can easily download and forward it to the recipient.",
  orderForm: {
    title: "ORDER VIDEO MESSAGE",
    backToPlan: "Back to packages",
    recipientSection: "Who is the video for?",
    recipientName: "Recipient's name",
    recipientNamePlaceholder: "E.g. John Smith",
    recipientAge: "Recipient's age (optional)",
    recipientAgePlaceholder: "E.g. 25",
    occasionSection: "What should be in the video?",
    occasion: {
      birthday: "Birthday",
      nameday: "Name day",
      anniversary: "Anniversary",
      motivation: "Workout motivation",
      graduation: "Graduation",
      wedding: "Wedding/Engagement",
      congratulation: "Congratulation",
      apology: "Apology",
      celebration: "Celebration/Party",
      prank: "Funny prank",
      other: "Other"
    },
    instructionsLabel: "What should I say in the video? (Provide details)",
    instructionsPlaceholder: "E.g. Wish John a happy 30th birthday and give him motivation for his workouts...",
    instructionsHelp: "Max. 500 characters. Describe in detail what you'd like me to say.",
    yourDataSection: "Order information",
    yourName: "Your full name",
    yourNamePlaceholder: "Enter your full name",
    yourEmail: "Your email",
    yourEmailPlaceholder: "example@email.com",
    emailHelp: "The completed video will be sent to this email address.",
    submitButton: "Order and pay",
    termsAgreement: "By submitting the order, you accept the terms of use and privacy policy.",
    orderSuccess: "Order sent!",
    orderSuccessDesc: "Thank you for your order! We will prepare the video message soon."
  }
};
